import { useState } from "react";
import { useDispatch } from "react-redux";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import OrdersDataTable from "../components/OrdersDataTable";
import { exportOrders } from "../Redux/Reducers/ProductSlice";

const ManageInvoices = () => {
  const dispatch = useDispatch();
  const [statusFilter, setStatusFilter] = useState("all");

  const handleExportOrders = () => {
    dispatch(exportOrders({ status: statusFilter }));
  };

  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        <DefaultTopBar
            title="Manage Orders"
            btnText="Export File"
            btnOnClick={handleExportOrders}
        />

        {/* TableDataLayer */}
        <OrdersDataTable
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
        />

      </MasterLayout>

    </>
  );
};

export default ManageInvoices; 
